export const getTimeFromNow = (unixTimestamp: number, inMillisecond: boolean = false): string => {
  const timeDiff = Date.now() - unixTimestamp * (inMillisecond ? 1 : 1000)

  if (timeDiff < 60000) {
    const seconds = Math.floor(timeDiff / 1000)
    return `${seconds} second${seconds > 1 ? "s" : ""} ago`
  } else if (timeDiff < 3600000) {
    const minutes = Math.floor(timeDiff / 60000)
    return minutes + " minute" + (minutes > 1 ? "s" : "") + " ago"
  } else if (timeDiff < 86400000) {
    const hours = Math.floor(timeDiff / 3600000)
    return hours + " hour" + (hours > 1 ? "s" : "") + " ago"
  } else if (timeDiff < 604800000) {
    const days = Math.floor(timeDiff / 86400000)
    return days + " day" + (days > 1 ? "s" : "") + " ago"
  } else if (timeDiff < 2419200000) {
    const week = Math.floor(timeDiff / 604800000)
    return week + " week" + (week > 1 ? "s" : "") + " ago"
  } else {
    const month = Math.floor(timeDiff / 2419200000)
    return month + " month" + (month > 1 ? "s" : "") + " ago"
  }
}
